/*
 * Slim v5.3.1 - Image Cropping Made Easy
 * Copyright (c) 2020 Rik Schennink - https://pqina.nl/slim
 */
import { NgModule } from '@angular/core';

import { Slim } from './slim.angular.component';

@NgModule({
  declarations: [
    Slim
  ],
  imports: [
  ],
  exports: [
    Slim
  ]
})

export class SlimModule { }